export const TextHumanize = (value) => {

    let words = value.match(/[A-Za-z][a-z]*/g) || []

    if (!words.length) {
        words = value.split('_') || []
    }

    return words.map((word, index) => index === 0 ? word.charAt(0).toUpperCase() + word.substring(1) : word.toLowerCase()).join(' ')
}